import { CART_STORAGE_VERSION } from "./cartUtils";

const CART_STORAGE_KEY = "imalandia_cart_v2";

export function loadStoredCart() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const rawCart = window.localStorage.getItem(CART_STORAGE_KEY);

    if (!rawCart) {
      return null;
    }

    const parsedCart = JSON.parse(rawCart);

    if (parsedCart.version !== CART_STORAGE_VERSION) {
      return null;
    }

    if (!Array.isArray(parsedCart.items)) {
      return null;
    }

    return parsedCart;
  } catch (error) {
    return null;
  }
}

export function saveStoredCart(cart) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(
      CART_STORAGE_KEY,
      JSON.stringify({
        version: CART_STORAGE_VERSION,
        items: cart.items,
        updatedAt: new Date().toISOString(),
      })
    );
  } catch (error) {
    // If storage is unavailable, the in-memory cart still works.
  }
}

export function clearStoredCart() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(CART_STORAGE_KEY);
}
